import React, { useMemo, useState } from 'react'
import { intCol, numCol, strCol } from '@integec/grid-tools/lib/cols'
import { Button, Input, InputNumber, Select } from 'antd'
import * as api from '../../../api/pgads'
import CommonScreen from '../CommonScreen'

import {
  UtilityUnitSelection,
  getApiTargetInfo,
  getEnvConfig,
  getPermitActions,
  getUnitNameMap,
  getUtilityNameMap,
  monthsMap,
} from 'core'
import moment from 'moment'
import { Label } from 'core/screen-util'
import { connect } from 'react-redux'
import { monthMapChoice } from 'core/utils'

const title = 'Additional Monthly Tracking'

const AddnMonthlyTracking = ({ targetInfo, unitNameMap, utilityNameMap }) => {
  const [month, setMonth] = useState('ALL')
  const [year, setYear] = useState(moment().year())
  const [insertEvent, setInsertEvent] = useState(false)
  const [monthlyTags, setMonthlyTags] = useState({})
  useState(
    _ =>
      api.getAdditionalMonthlyTags(targetInfo).fork(
        e => console.log(e),
        d => setMonthlyTags(d[0])
      ),
    []
  )

  const newHeaders = useMemo(
    _ => {
      const headers = [
        strCol({
          ident: 'utility',
          display: 'Utility',
          width: 450,
          isRequired: true,
          sortOrder: 'asc',
          ellipsis: true,
          dataFormatter: ({ value }) => utilityNameMap[value] || value,
          sortIndexGetter: ({ rowData }) =>
            utilityNameMap[rowData.unitId] || rowData.unitId,
        }),
        strCol({
          ident: 'unitId',
          display: 'Unit',
          width: 350,
          isKey: true,
          sortOrder: 'asc',
          ellipsis: true,
          dataFormatter: ({ value }) => unitNameMap[value] || value,
          sortIndexGetter: ({ rowData }) =>
            unitNameMap[rowData.unitId] || rowData.unitId,
        }),
        intCol({ ident: 'year', display: 'Year', isKey: true }),
        intCol({
          ident: 'month',
          display: 'Month',
          isKey: true,
          ...monthMapChoice,
        }),
      ]
      for (let i = 1; i <= 10; i++)
        headers.push(
          numCol({
            ident: 'number' + i,
            display: monthlyTags['header' + i] || '',
            isFiltered: true,
            idx: i,
          })
        )
      for (let i = 1; i <= 5; i++)
        headers.push(
          strCol({
            ident: 'string' + i,
            display: monthlyTags['header' + (10 + i)] || '',
            isFiltered: true,
            ellipsis: true,
            alignment: 'left',
            width: 250,
            insert: true,
          })
        )

      const fd = headers.filter(d => d.display !== d.ident)

      return fd
    },
    [monthlyTags, unitNameMap, utilityNameMap]
  )

  const insertComp = ({ insertData, setInsertData, onAdd, onCancel }) => {
    return (
      <div style={{ gap: '5px' }}>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr',
            gap: 5,
          }}
        >
          <Label>Select Utility/Unit :</Label>
          <UtilityUnitSelection
            utility={insertData.utility}
            unit={insertData.unitId}
            onUnitChange={value => {
              // setUtilityUnit(value)
              setInsertData({
                ...insertData,
                utility: value[0],
                unit: value[1].substr(3),
                unitId: value[1],
              })
            }}
            casStyle={{ marginLeft: '5px', gridColumnEnd: 'span 3' }}
          />
          <Label style={{ marginLeft: '5px' }}>Year :</Label>
          <InputNumber
            value={insertData.year}
            onChange={value =>
              setInsertData({
                ...insertData,
                year: value,
              })
            }
            style={{ width: '100px', marginLeft: '5px' }}
          />
          <Label style={{ marginLeft: '5px' }}>Month :</Label>
          <Select
            value={insertData.month}
            onChange={value =>
              setInsertData({
                ...insertData,
                month: value,
              })
            }
          >
            {Object.keys(monthsMap).map(i => (
              <Select.Option value={i} key={i}>
                {monthsMap[i]}
              </Select.Option>
            ))}
          </Select>

          {newHeaders
            .filter(f => f.ident.includes('number'))
            .map(nd => (
              <>
                <Label>{nd.display} : </Label>
                <InputNumber
                  value={insertData[nd.ident]}
                  onChange={val => {
                    setInsertData({ ...insertData, [nd.ident]: val })
                  }}
                  max={monthlyTags['maxVal' + nd.idx]}
                  min={monthlyTags['minVal' + nd.idx]}
                />
              </>
            ))}
        </div>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '100px auto',
            gap: 5,
            marginTop: '5px',
            marginBottom: '5px',
          }}
        >
          {newHeaders
            .filter(f => f.ident.includes('string') && f.insert)
            .map(nd => (
              <>
                <Label key={nd.ident + 'l'}>{nd.display} : </Label>
                <Input
                  key={nd.ident + 'v'}
                  style={{ gridColumnEnd: 'span 1' }}
                  value={insertData[nd.ident]}
                  onChange={e => {
                    setInsertData({ ...insertData, [nd.ident]: e.target.value })
                  }}
                />
              </>
            ))}
        </div>
        <div style={{ marginLeft: '10px', gridColumnEnd: 'span 3' }}>
          <Button type="primary" onClick={() => onAdd(true)}>
            Add
          </Button>
          <Button
            style={{ marginLeft: '20px' }}
            type="primary"
            onClick={() => onAdd(false)}
          >
            Add & Hide
          </Button>
          <Button
            style={{ marginLeft: '20px' }}
            type="danger"
            onClick={onCancel}
          >
            Cancel
          </Button>
        </div>
      </div>
    )
  }

  const screenCriteria = _ => (
    <>
      <Select
        style={{ width: '130px', marginLeft: '5px' }}
        value={month}
        onChange={val => setMonth(val)}
      >
        <Select.Option key="ALL" value="ALL">
          ALL
        </Select.Option>
        {Object.keys(monthsMap).map(m => (
          <Select.Option key={m} value={m}>
            {m}-{monthsMap[m]}
          </Select.Option>
        ))}
      </Select>
      <InputNumber
        value={year}
        onChange={value => setYear(value)}
        style={{ width: '100px', marginLeft: '15px' }}
      />
    </>
  )

  return (
    <CommonScreen
      withUnitSelection={false}
      isAdminScreen
      title={title}
      header={newHeaders}
      saveTask={api.saveAddnMonthlyTracking}
      retrieveTask={api.getAddnMonthlyTracking}
      withCriteria={() => ({
        month,
        year,
      })}
      deleteTask={api.deleteAddnMonthlyTracking}
      screenCriteria={screenCriteria}
      altBy={d => d.unitId}
      sortOptions={newHeaders}
      widthOffset={100}
      heightOffset={270}
      insertComp={insertEvent && insertComp}
      onInsertEvent={b => setInsertEvent(b)}
      insertCompHeight={0}
      autoFixColByKey={false}
      headerRowHeight={60}
      defaultInsertData={{ year: year, month: month }}
    />
  )
}

const mapStateToProps = state => ({
  unitNameMap: getUnitNameMap(state),
  utilityNameMap: getUtilityNameMap(state),
  envConfig: getEnvConfig(state),
  actionPermits: getPermitActions(state),
  targetInfo: getApiTargetInfo(state),
})

export default connect(mapStateToProps)(AddnMonthlyTracking)
